import { surnameUpdateApi } from "../../api/surname/surnameUpdateApi"

type PayloadShape = Parameters<typeof surnameUpdateApi>[0]

export async function surnameUpdateService(payload: PayloadShape, token: string) {
	return await surnameUpdateApi(payload, token)
}
